//Main Game
import Spaceships from '../components/maingame/spaceships';
import Workers from '../components/maingame/workers';
import Mine from '../components/maingame/mine';

//Marketplace
import MarketplaceSpaceships from '../components/marketplace/spaceships';
import MarketplaceWorkers from '../components/marketplace/workers';

export const routes = [
  { path: `${process.env.PUBLIC_URL}/maingame/spaceships/:layout`, Component: Spaceships },
  { path: `${process.env.PUBLIC_URL}/maingame/workers/:layout`, Component: Workers },
  { path: `${process.env.PUBLIC_URL}/maingame/mine/:layout`, Component: Mine },
  { path: `${process.env.PUBLIC_URL}/marketplace/spaceships/:layout`, Component: MarketplaceSpaceships },
  { path: `${process.env.PUBLIC_URL}/marketplace/workers/:layout`, Component: MarketplaceWorkers },
];
